export const primaryFilterOptions = [
  { id: 0, name: "All" },
  { id: 1, name: "Bankable" },
  { id: 2, name: "Require Concessional Finance" },
  { id: 3, name: "Require Grants" },
];

export const secondaryFilterOptions = [
  { id: 0, name: "All" },
  { id: 1, name: "Community Resilience & Health" },
  { id: 2, name: "Infrastructure Resilience" },
  { id: 3, name: "Nature-Based Solutions" },
  { id: 4, name: "Risk Management & Early Warning" },
];

export const projectData = [
  {
    id: 1,
    title:
      "Flood prevention and clean energy via waste collection and incineration",
    description:
      "Part of an integrated waste management solution to minimize waste at landfills; significant investor interest and A&R ROI.",
    beneficiaries: "2.9M",
    impact: "$940M",
    cost: "$450M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Flood prevention and clean energy via waste collection and incineration.pdf"),
  },
  {
    id: 2,
    title:
      "Targeted wastewater treatment to prevent flood-contaminated drinking water",
    description:
      "A treatment plant offers a strong economic and A&R ROI, and has numerous aligned funders, indicating it can be successfully implemented.",
    beneficiaries: "5.4M",
    impact: "$1.65B",
    cost: "$275M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Targeted wastewater treatment to prevent flood-contaminated drinking water.pdf"),
  },
  {
    id: 3,
    title: "Early warning system for extreme weather events",
    description:
      "Digital warning systems have the potential for significant human impact, typically financed by specialized funds.",
    beneficiaries: "1.5M",
    impact: "$51M",
    cost: "$20M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 1,
    secondary: 4,
    coBenefits: ["SDGs Addressed"],
    pdfPath: require("../../assets/pdfs/LCARP Early warning system for extreme weather events.pdf"),
  },
  {
    id: 4,
    title:
      "Implement surveillance systems for climate change-related existing and new diseases",
    description:
      "Building resilience in the health sector is critical in a developing country, and is expected to have significant high impact; aligned with LASG priorities.",
    beneficiaries: "27M",
    impact: "TBD",
    cost: "$10M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 1,
    secondary: 1,
    coBenefits: [],
    pdfPath: require("../../assets/pdfs/LCARP Implement surveillance systems.pdf"),
  },
  {
    id: 5,
    title:
      "Clean drinking water source in areas with falling groundwater supply",
    description:
      "Building resilience in the water sector is critical, particularly in Lagos' context due to the low-lying water tables; huge impact on Lagos' population",
    beneficiaries: "12.1M",
    impact: "$1.7B",
    cost: "$1B",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Clean drinking water source in areas with failing groundwater supply.pdf"),
  },
  {
    id: 6,
    title: "Resilient road and transit links in inundated areas",
    description:
      "A resilient highway offers a strong A&R ROI, with its major revenue model arising from tolling options",
    beneficiaries: "7.5M",
    impact: "$7.2B",
    cost: "$270M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: ["Women as Beneficiaries"],
    pdfPath: require("../../assets/pdfs/LCARP Resilient road and transit links in inundated areas.pdf"),
  },
  {
    id: 7,
    title: "Inland flood prevention through mangrove restoration across Lagos",
    description:
      "There is excitement in investor and conservation circles for mangrove restoration; scale needs to discussed",
    beneficiaries: "510K",
    impact: "$2.6B",
    cost: "$25M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 3,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Inland flood prevention through mangrove restoration.pdf"),
  },
  {
    id: 8,
    title: "Water-resilient agriculture and agroforestry",
    description:
      "There is excitement in investor and conservation circles for urban agriculture as A&R and food resilience; operability needs further proof for scaled solutions",
    beneficiaries: "470K",
    impact: "TBD",
    cost: "$7M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 1,
    secondary: 3,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Water-resilient agriculture and agroforestry.pdf"),
  },
  {
    id: 9,
    title:
      "Relocating permanently displaced populations to climate responsive housing",
    description:
      "Investors have expressed interest in low-mid income housing, citing guaranteed offtake agreements as a major enabler to implementation",
    beneficiaries: "1.5M",
    impact: "$48M",
    cost: "$275M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 1,
    secondary: 1,
    coBenefits: ["Women as Beneficiaries"],
    pdfPath: require("../../assets/pdfs/LCARP Relocating permanently displaced populations.pdf"),
  },
  {
    id: 10,
    title: "Protecting inundated power and communications infrastructure",
    description:
      "Hardening and modernizing Lagos' power grid will make it more resilient to flooding, and offers opportunities to green the grid with decentralized local contributors",
    beneficiaries: "10M",
    impact: "$967M",
    cost: "$115M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: ["Emission Reduction", "SDGs Addressed"],
    pdfPath: require("../../assets/pdfs/LCARP Protecting inundated power and communications infrastructure.pdf"),
  },
  {
    id: 11,
    title:
      "Resilient aquafarming facilities designed to minimize yield losses caused by flooding",
    description:
      "Developing more resilient aquafarming facilities will reduce the effects of flooding on yield and overall livelihood of aquafarmers in coastal areas of Lagos",
    beneficiaries: "500K",
    impact: "$13M",
    cost: "$50M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 1,
    coBenefits: [
      "Sustainable Practices",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
    pdfPath: require("../../assets/pdfs/LCARP Resilient aquafarming facilities.pdf"),
  },

  {
    id: 12,
    title:
      "Rainwater harvesting on commercial buildings to reduce extreme rainfall-related flooding",
    description:
      "Commercial rainwater harvesting as an A&R and agri-productivity solution is suitable for rural areas; impact at scale in urban areas needs further investigation",
    beneficiaries: "10K",
    impact: "$80M",
    cost: "$3M",
    benefits: ["extremeRainfall"],
    primary: 1,
    secondary: 2,
    coBenefits: [],
    pdfPath: require("../../assets/pdfs/LCARP Rainwater harvesting.pdf"),
  },
  {
    id: 13,
    title: "Resilient water links for Lagos inner-city connections",
    description:
      "Project implementation by consortium of the Agence Française de Développement (AFD) and European institutions",
    beneficiaries: "2M",
    impact: "$2.6B",
    cost: "$445M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 1,
    secondary: 2,
    coBenefits: [
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 14,
    title: "Strengthened sea defenses to reinforce existing coastal embankment",
    description:
      "Enhancing existing coastal barriers to mitigate storm surges and rising sea levels; critical for reducing economic losses in vulnerable coastal areas",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$1B",
    benefits: ["seaLevelRise"],
    primary: 2,
    secondary: 2,
    coBenefits: ["Women as Beneficiaries"],
  },
  {
    id: 15,
    title: "Inner-city flood prevention through new primary drainage systems",
    description:
      "Developing large-scale, climate-resilient drainage systems designed to channel heavy rainwater efficiently and reduce urban flooding impacts",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$3B",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 2,
    secondary: 2,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",

      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 16,
    title:
      "Inner-city flood prevention through new and rehabilitated secondary drainage systems",
    description:
      "Upgrading secondary drainage networks to complement primary systems; aims to enhance overall floodwater management in densely populated areas",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$170M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 2,
    secondary: 2,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",

      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 17,
    title:
      "Flood-enhanced inner-city roads across 10 vulnerable governmental areas",
    description:
      "Redesigned road networks incorporating flood mitigation technologies; offers dual benefits of accessibility and reduced water accumulation",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$350M",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 2,
    secondary: 2,
    coBenefits: ["Women as Beneficiaries"],
  },
  {
    id: 18,
    title: "Retrofitted pavements of 1,800km for extreme heat mitigation",
    description:
      "Pavement resurfacing with heat-reflective materials to combat rising urban temperatures",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$70M",
    benefits: ["extremeHeat", "seaLevelRise"],
    primary: 2,
    secondary: 2,
    coBenefits: [],
  },
  {
    id: 19,
    title: "Heat-alleviating adaptation of social infrastructures",
    description:
      "Retrofitting of 350 manufacturing plants with cool surfaces, green building envelopes, and cooling systems in Kosofe, Apapa, and Eti Osa",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$70M",
    benefits: ["extremeHeat"],
    primary: 2,
    secondary: 1,
    coBenefits: ["Carbon Credits", "SDGs Addressed", "Women as Beneficiaries"],
  },
  {
    id: 20,
    title: "Flood- and heat-retrofit of schools and health centers",
    description:
      "Retrofitting or relocating 500 schools and 350 health facilities with dry-proofing and cooling systems to enhance resilience",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$20M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 3,
    secondary: 1,
    coBenefits: [
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 21,
    title: "Heat-reducing redesign of governmental area structures",
    description:
      "Re-designing 5 LGAs (Badagry, Ikorodu, Ibeju Lekki, Epe, and part of Eti Osa) with improved street grids and shading structures",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$2M",
    benefits: ["extremeHeat"],
    primary: 2,
    secondary: 4,
    coBenefits: ["Women as Beneficiaries"],
  },
  {
    id: 22,
    title: "Planting of climate-resilient trees across Lagos",
    description:
      "Planting 50,000 climate-resilient trees annually across Lagos to alleviate the impact of extreme heat",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$1.5M",
    benefits: ["extremeHeat"],
    primary: 3,
    secondary: 3,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",
      "Carbon Credits",
      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 23,
    title: "Rehabilitate and maintenance of existing urban parks across Lagos",
    description:
      "Rehabilitate and maintain existing 300+ urban parks across Lagos to enhance their climate resilience and provide cooling effects for surrounding neighborhoods",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$50M",
    benefits: ["extremeHeat"],
    primary: 3,
    secondary: 3,
    coBenefits: [
      "Emission Reduction",
      "Sustainable Practices",

      "SDGs Addressed",
      "Women as Beneficiaries",
      "Women as Changemakers",
    ],
  },
  {
    id: 24,
    title: "Nature-based inland flood solutions",
    description:
      "Implementing bioswales, rain gardens, etc. to naturally mitigate the impact of inland flooding",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall"],
    primary: 3,
    secondary: 3,
    coBenefits: [
      "Emission Reduction",

      "SDGs Addressed",
      "Women as Beneficiaries",
    ],
  },
  {
    id: 25,
    title: "Active water management with flood-resilient pumping stations",
    description:
      "Establishing pumping stations for active water removal to maintain proper water flow and reduce flood risks in vulnerable areas",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall"],
    primary: 3,
    secondary: 4,
    coBenefits: ["Sustainable Practices", "Women as Beneficiaries"],
  },
  {
    id: 26,
    title: "Expanded stormwater channels for enhanced flood management",
    description:
      "Constructing larger, more efficient stormwater channels to handle increased rainfall and minimize urban flooding",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall"],
    primary: 3,
    secondary: 2,
    coBenefits: ["Sustainable Practices", "Women as Beneficiaries"],
  },
  {
    id: 27,
    title:
      "Protective artificial flood barriers for climate-resilient community areas",
    description:
      "Constructing barriers or levees to protect vulnerable areas from flood events due to extreme rainfall",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall"],
    primary: 3,
    secondary: 2,
    coBenefits: [
      "Sustainable Practices",
      "SDGs Addressed",
      "Women as Beneficiaries",
    ],
  },
  {
    id: 28,
    title: "Safe relocation and empowerment for vulnerable populations",
    description:
      "Relocating 320K vulnerable populations from 10 exposed areas, including empowerment programs to aid displaced populations",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$500M",
    benefits: ["seaLevelRise"],
    primary: 3,
    secondary: 1,
    coBenefits: ["Women as Beneficiaries"],
  },
  {
    id: 29,
    title:
      "Medical infrastructure blueprint alleviating climate risk-related healthcare demand",
    description:
      "Building new hospitals and primary healthcare facilities in underserved regions of Lagos to address climate-related healthcare demands",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall", "seaLevelRise"],
    primary: 2,
    secondary: 1,
    coBenefits: ["SDGs Addressed", "Women as Beneficiaries"],
  },
  {
    id: 30,
    title: "Digitalization to enable a climate-resilient healthcare system",
    description:
      "Increasing use of electronic medical records and smart health Information platform",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "TBD",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 2,
    secondary: 1,
    coBenefits: ["SDGs Addressed", "Women as Beneficiaries"],
  },
  {
    id: 31,
    title: "Creation of Lagos adaptation emergency response fund",
    description:
      "Mobilizing support for impacted vulnerable population incl. insurance coverage; financing repairs and reconstruction of damaged infrastructure",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$1B",
    benefits: ["seaLevelRise"],
    primary: 3,
    secondary: 4,
    coBenefits: ["SDGs Addressed", "Women as Beneficiaries"],
  },
  {
    id: 32,
    title:
      "Health insurance access for vulnerable communities in exposed governmental areas",
    description:
      "Providing health insurance to 320K vulnerable populations in exposed areas",
    beneficiaries: "TBD",
    impact: "TBD",
    cost: "$20M",
    benefits: ["extremeRainfall", "extremeHeat", "seaLevelRise"],
    primary: 2,
    secondary: 1,
    coBenefits: ["SDGs Addressed", "Women as Beneficiaries"],
  },
];
